import React from 'react';
import { LEGAL_ENTITY_NAME, LEGAL_REGISTERED_ADDRESS, LEGAL_SUPPORT_EMAIL } from '../legalInfo';
import './Legal.css';

export const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-updated">Last updated: July 12, 2026</p>

        <div className="legal-section">
          <h2>Company Information</h2>
          <div className="legal-company-box">
            <p className="legal-entity-name">{LEGAL_ENTITY_NAME}</p>
            <p>Registered address: {LEGAL_REGISTERED_ADDRESS}</p>
            <p>Contact: <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a></p>
          </div>
        </div>

        <div className="legal-section">
          <h2>1. Information We Collect</h2>
          <p>
            {LEGAL_ENTITY_NAME} collects information you provide directly, such as your name,
            email address, company name, and any details submitted through our contact or scoping
            forms. We may also collect limited technical data (such as browser type and IP address)
            for analytics and security purposes.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To respond to inquiries and scope project requests</li>
            <li>To provide, maintain, and improve our services</li>
            <li>To process payments where applicable</li>
            <li>To comply with legal and regulatory obligations</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>3. Data Sharing</h2>
          <p>
            We do not sell your personal information. We may share data with trusted service
            providers (such as payment processors and hosting providers) strictly for the purpose
            of delivering our services, and only to the extent necessary.
          </p>
        </div>

        <div className="legal-section">
          <h2>4. Data Security</h2>
          <p>
            We implement reasonable technical and organizational measures to protect your
            information against unauthorized access, alteration, or disclosure.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Your Rights</h2>
          <p>
            You may request access to, correction of, or deletion of your personal information by
            contacting us using the details below.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Contact &amp; Grievance Officer</h2>
          <p>
            For privacy-related questions or grievances, please contact {LEGAL_ENTITY_NAME} at{' '}
            <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a> or write to us at the
            registered address above.
          </p>
        </div>
      </div>
    </div>
  );
};
